<template>
  <div class="contentbox">
    <div class="media-add-ep-list">
      <div class="top-search">
        <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline select-nobg">
          <el-form-item label="书名" prop="bookName">
            <el-input v-model="formInline.bookName" placeholder="请输入书名" clearable @keyup.enter.native="search"
              @clear="search" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="书ID" prop="bookId">
            <el-input v-model="formInline.bookId" placeholder="请输入书ID" clearable @keyup.enter.native="search"
              @clear="search" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="投放链接ID" prop="tfid">
            <el-input v-model="formInline.tfid" placeholder="请输入投放链接ID" clearable @keyup.enter.native="search"
              @clear="search" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="日期：">
						<el-date-picker
							v-model="dataTime"
							class="pickerData"
							format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="margin-right: 10px; width: 400px" clearable @change="search">
						</el-date-picker>
					</el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loading">
					<el-table-column prop="bookInfo" label="书籍信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>书名：{{scope.row.bookName}}</p>
								<!-- <p>别名：{{scope.row.nickName}}</p> -->
								<p>书ID：{{scope.row.bookId}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="userCount" label="总阅读用户数">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.userCount}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="recUserCount" label="充值人数" >
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.recUserCount}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="money" label="充值金额" >
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.money}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="rechargeVipInfo" label="充值会员信息" >
						<template slot-scope="scope">
							<div class="td-info">
								<p>连续包月: {{scope.row.everyMonthly}}人</p>
								<p>连续包季: {{scope.row.everySeason}}人</p>
								<p>包月会员: {{scope.row.monthly}}人</p>
								<p>包季会员: {{scope.row.season}}人</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="avgChapCount" label="人均观看章节数">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.avgChapCount}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleDetails(scope.row)">详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-sizes="[20, 50, 100, 200, 500]"
            :page-size="tableData.pageSize"
            background
            :current-page="currentPage"
            layout="sizes, prev, pager, next, jumper, ->, total"
            :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>

    </div>

    <!-- 详情 -->
    <loss-table :visible.sync="dialogInfoVisible"  @cancelDialogApp="cancelDialogApp" :BookInfo="BookInfo" :tfid="tfid ? String(tfid) : ''" :Time="dataTime"></loss-table>

  </div>
</template>
<script>
import LossTable from '@/components/wb/LossTable'
export default {
  components: {
    LossTable
  },
  data() {
    return {
      dataTime:[],
      formInline: {
        bookName: "",
        bookId: "",
        tfid: "",
        statStartDate: "",
        statEndDate: "",
      },
      currentPage:1,
      loading:false,
      tableData: {
        pageSize: 20,
        pageNo: 1,
        totalPage: 1,
        totalNum: 0,
        result: []
      },
      dialogInfoVisible:false,
      BookInfo:null,
      tfid:'',

    }
  },
  computed: {},
  watch: {
  },
  mounted: function () {

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    
    // 格式化为 'yyyy-MM-dd'
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    // 设置为昨天到昨天的范围
    this.dataTime = [formatDate(yesterday), formatDate(yesterday)];

    this.getTableData()
  },
  methods: {
    // 查询
    search() {
      this.currentPage = 1
      this.loading = true
      this.getTableData()
    },

    // 重置
    resetQuery() {
      this.loading = true
      this.$refs['formInline'].resetFields()
      this.dataTime = []
      this.getTableData()
    },

    // pageSize切换
    handleSizeChange (val) {
      this.tableData.pageSize  = val
      this.currentPage = 1
      this.loading = true
      this.getTableData()
    },
    handleCurrentChange(value) {
      this.currentPage = value
      this.loading = true
      this.getTableData()
    },

    // 表格列表
    getTableData(){
      let json2 = {
        pageNo: this.currentPage,
        pageSize: this.tableData.pageSize
      };
      this.formInline.statStartDate = this.dataTime ? this.dataTime[0] : ''
      this.formInline.statEndDate = this.dataTime ? this.dataTime[1] : ''
      let json1 = this.formInline;
      let paramJson = { ...json1, ...json2 };
      this.axios({
        method:'get',
        url:'/novel/data/daily/list',
        params:paramJson
      }).then((response)=>{
       if (response.data.head.flag === 0) {
          this.tableData = response.data.content
          this.loading = false
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
    },

    // 点击详情
    handleDetails(row){
      console.log("详情",row)
      this.BookInfo = row
      this.tfid = row.tfId
      this.dialogInfoVisible = true
    },

    // 关闭详情
    cancelDialogApp(){
      this.dialogInfoVisible = false
    }

  }
}
</script>
